<template>
  <BreadCrumb PageTitle="Gutters" />
  <GuttersContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import GuttersContent from "../../template-components/Utilities/Gutters/GuttersContent.vue";

export default defineComponent({
  name: "GuttersPage",
  components: {
    BreadCrumb,
    GuttersContent,
  },
});
</script>